import { render, staticRenderFns } from "./KRSApproved.vue?vue&type=template&id=d75919c4"
import script from "./KRSApproved.vue?vue&type=script&lang=js"
export * from "./KRSApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports